import { render } from "./manage-seo.vue?vue&type=template&id=30588c98"
import script from "./manage-seo.vue?vue&type=script&lang=js"
export * from "./manage-seo.vue?vue&type=script&lang=js"

import "./manage-seo.vue?vue&type=style&index=0&id=30588c98&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__